import {Skeleton, Stack} from "@mui/material";
import React from "react";

const TableHook = ({header, tableData, loading}) => {
    // console.log("header", header, tableData);
    return (
        <div className="profile-table-main is-desktop">
            <table className="profile-table mt-3">
                <thead className="t-head">
                    <tr>
                        {header.map((head, index) => (
                            <th key={index} className={head.sort ? "sort-header" : ""} >
                                {head.label}
                                <span>{head.icon}</span>
                            </th>
                        ))}
                    </tr>
                </thead>
                {loading ? (
                    <tbody>
                        {Array.from({length: 4}).map((_, index) => (
                            <tr key={index}>
                                {header.map((head, index) => (
                                    <td key={index}>
                                        <Stack>
                                            <Skeleton sx={{marginTop: "10px"}} variant="rounded" height={40} />
                                        </Stack>
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                ) : (
                    <tbody>
  {tableData.map((row, index) => (
    <React.Fragment key={index}>
      <tr>
        {row.map((data, i) => (
          <td
            key={i}
            
          >
            {data}
          </td>
        ))}
      </tr>
      {/* Spacer row to add minimal vertical space */}
      {index !== tableData.length - 1 && (
        <tr>
          <td
            colSpan={row.length}
            style={{
              height: "6px",       // Reduce space here
              padding: 0,
              margin: 0,
              border: "none",
            }}
          ></td>
        </tr>
      )}
    </React.Fragment>
  ))}
</tbody>


                )}
                {tableData.length == 0 && !loading && (
                    <tbody>
                        <tr>
                            <td colSpan={header.length}>
                                <div className="d-flex justify-content-center my-auto fw-bold pb-5">No Data found.</div>
                            </td>
                        </tr>
                    </tbody>
                )}
            </table>
        </div>
    );
};

export default TableHook;
